var app = window.app = (function () {
    var body = $('#app').first();

    return {
        body: body,
        init: function () {
            this.AwesomeScrollbar = window.AwesomeScrollbar || {};
            this.AwesomeHorizontalScrollbar = window.AwesomeHorizontalScrollbar || {};
            this.Balance = window.Balance || { init: function () { } };
            this.CurrentDatetime = window.CurrentDatetime || { init: function () { } };
            this.CustomSelect = window.CustomSelect || {};
            this.Favorites = window.Favorites || { init: function () { } };
            this.MainNavigation = window.MainNavigation || { init: function () { } };
            this.VerticalMenu = window.VerticalMenu || {};
            this.ModalMarkets = window.ModalMarkets || {};
            this.Broadcast = window.Broadcast || {};
            this.ModalWindow = window.ModalWindow || {};
            this.ModeTableLive = window.ModeTableLive || {};
            this.ModeTablePrematch = window.ModeTablePrematch || {};
            this.PageContent = window.PageContent || { init: function () { } };
            this.SportsFilter = window.SportsFilter || {};
            this.Tooltip = window.Tooltip || {};
            this.Superexpress = window.Superexpress || {};
            this.OpenEvent = window.OpenEvent || {};
            this.ErrorHandler = window.ErrorHandler || {};
            this.LogoutTimer = window.LogoutTimer || {};
            this.Search = window.Search || {};
            this.Multi = window.Multi || {};
            this.TimeZone = window.TimeZone || { init: function () { } };

            ////shared inits
            this.MainNavigation.init();     // 8.5 ms -- first method + atr-selectors
            this.CurrentDatetime.init();    // 1.1 ms
            this.Favorites.init();          // 0.6 ms
            this.PageContent.init();        // 4.0 ms --awesome sb
            this.Balance.init();            // 1.0 ms
            this.TimeZone.init();

            // disable drag and drop on links (default browsers feature)
            //TODO: в цуписе включить
            //$(document).on('dragstart', 'a', () => false);

            body.addClass('m-straight-visible');
        },
        //TODO: в utils
        bindModelHtml: function (obj, property, domElement) {
            if (obj.hasOwnProperty('prevValues') === false)
                obj.prevValues = {};

            obj.prevValues[property] = null;

            Object.defineProperty(obj, property, {
                get: function () {
                    return domElement.html();
                },
                set: function (newValue) {
                    if (obj.prevValues[property] !== newValue) {
                        obj.prevValues[property] = newValue;
                        domElement.html(newValue);
                    }
                },
                configurable: true
            });
        },
        //TODO: в utils
        inputIsInteger: function (e) {
            return !(e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57));
        },
        //TODO: в utils
        numberToString: function (num) {
            return num ? num.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') : '0';
        },
        //TODO: в utils
        stringToNumber: function (str) {
            return str ? parseInt(str.replace(/\s+/g, '')) : null;
        },
        getUrlParams: function (param) {
            var req = window.location.search.substring(1);
            return (req.length === 0)
                ? undefined
                : req.split('&').map(function (x) {
                    return x.split('=');
                }).reduce(function (map, obj) {
                    map[obj[0]] = obj[1].split(',');
                    return map;
                }, {})[param];
        },
        enableLoading: function () {
            body.addClass('is-loading');
        },
        disableLoading: function () {
            body.removeClass('is-loading');
        },
        console: localStorage.getItem('debug') ? window.console : {
            log: function () { },
            error: function () { },
            debug: function () { },
            warn: function () { },
            info: function () { },
            time: function () { },
            timeEnd: function () { },
            group: function () { }
        },
        debug: {
            enable: function (type) {
                type ? localStorage.setItem('debug_' + app.debug.types[type], true) : localStorage.setItem('debug', true);
                window.location.reload();
                return true;
            },
            disable: function (type) {
                type ? localStorage.removeItem('debug_' + app.debug.types[type]) : localStorage.removeItem('debug');
                window.location.reload();
                return false;
            },
            log: function (msg, type) {
                if (localStorage.getItem('debug_' + this.types[type])) {
                    console.log(msg);
                }
            }
        },
        generateGUID: function () {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        htmlSvgIcon: function (filename, classname) {
            return '<svg class="icon ' + classname + '"><use xlink:href="/Content/cps/images/sprites/svg-icons.svg#' + filename + '"></use></svg>';
        },
        isIE: function () {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        },
        svgSports: function (sportId, className) {
            sportId = sportId || '0';
            className = className || '';
            return '<svg class="icon icon-sport icon-sport-' + sportId + ' ' + className + '"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + globalAppSettings.svg.defaultSpriteSports + '#sport-' + sportId + '"></use></svg>';
        }
    };
}());

$(function () {
    app.init();

    if ($('#classic-betting-cart').length > 0) {
        if (globalAppSettings.isFreeBetEnabled) {
            if (Freebet) {
                Freebet.init();
            }
        }
        BettingCart.load();
        BettingCart.settings.bindUI();
    }
    if (globalAppSettings.isMobileDevice && window.Mobile) {
        window.Mobile.init();
    }



    // switch-case helper for Handlebars
    if (typeof(Handlebars) !== 'undefined') {
        Handlebars.registerHelper('switch', function (value, options) {
            this.switch_value = value;
            this.switch_break = false;
            return options.fn(this);
        });

        Handlebars.registerHelper('case', function (value, options) {
            if (value == this.switch_value) {
                this.switch_break = true;
                return options.fn(this);
            }
        });

        Handlebars.registerHelper('default', function (value, options) {
            if (this.switch_break == false) {
                return value;
            }
        });

        Handlebars.registerHelper('if_eq', function (v1, v2, options) {
            if (v1 === v2) {
                return options.fn(this);
            }
            return options.inverse(this);
        });
    }
});

// polyfill for ie
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}